export default __webpack_public_path__ + "static/media/TextCharacter.dfd6ee22.ico";